import has from 'lodash.has';
import Logger from './logger';

const log = new Logger();
const defaultData = {
  trialStatus: null,
  emailValidationResult: null,
  message: ''
};

// TODO: Flesh this out so that the error payload is always the same shape
export default (response) => {
  if (has(response, 'data')) {
    return response;
  }

  const newResponse = {
    data: {},
    status: response.status
  };

  delete response.status;

  newResponse.data = Object.assign({}, defaultData, response);

  log.debug({
    category: 'helpers',
    message: 'normalizeErrorPayload',
    data: {
      response: newResponse
    }
  });

  return newResponse;
};
